import { Button, Popconfirm, Tag, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from '@nic/commons'
import { useScopeInfo } from '../../Hooks/useScopeInfo'
import { AssignmentRequestActionsProps } from '../ButtonsAssignmentRequestActions'
import { useAssignRequestToMe } from './useAssignRequestToMe'
import { printAssignmentRequestActionError } from './printAssignmentRequestActionError'
import { UserAddOutlined } from '@ant-design/icons'
import { stringify } from 'qs'
import { useRouter } from '../../Hooks/useRouter'

import styled, { keyframes, css } from 'styled-components'

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(82, 196, 26, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
`

const FlashingButton = styled(Button) <{ flash?: boolean }>`
  ${props => props.flash && !props.disabled && css`
    animation: ${pulse} 2s infinite;
    border-radius: 50%;
  `}
`

export function ButtonAssignToMe(props: AssignmentRequestActionsProps & { flash?: boolean; showAsPrimary?: boolean }) {
  const t = useTranslation()
  const router = useRouter()
  const { scope } = useScopeInfo()
  const { loading, error, handleAssignRequestToMe } = useAssignRequestToMe()

  if (error) {
    return <Tag color={'red'}>{printAssignmentRequestActionError({ error })}</Tag>
  }

  const handleOnClick = () => {
    handleAssignRequestToMe(props.requestId, scope).then(() => {
      if (props.onSuccess) {
        props.onSuccess && props.onSuccess()
      } else {
        router.history.push(
          router.pathname + '?' + stringify({ ...router.query, reload: new Date() }),
        )
      }
    })
  }

  const buttonStyle = props.showAsPrimary && props.disableAssignToMeButton
    ? { borderRadius: '50%' }
    : undefined

  const assignToMeButton = (<FlashingButton
    flash={props.flash}
    data-cy="assignToMeButton"
    icon={<UserAddOutlined />}
    type={props.showAsPrimary ? 'primary' : 'link'}
    style={buttonStyle}
    disabled={props.disableAssignToMeButton}
    loading={loading}
  />)

  return props.disableAssignToMeButton ? assignToMeButton : (
    <Tooltip title={t('assignmentRequests.action.assignToMe')}>
      <Popconfirm title={t('assignmentRequests.message.assignToMe')}
        onConfirm={handleOnClick}
        okText={t('yes')}
        cancelText={t('no')}>
        {assignToMeButton}
      </Popconfirm>
    </Tooltip>
  )

}
